import { render } from "./RowWithLabel.vue?vue&type=template&id=4f04f07d&scoped=true"
import script from "./RowWithLabel.vue?vue&type=script&lang=js"
export * from "./RowWithLabel.vue?vue&type=script&lang=js"

import "./RowWithLabel.vue?vue&type=style&index=0&id=4f04f07d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f04f07d"]])

export default __exports__